
    import { Component, Vue } from 'vue-property-decorator'
    import store from '../../../store'
    import {isAuth} from "@/utils/user";
    import BatchIn from './bacth-in'
    import pbxxSchoolUserWorkVue from './pbxx-school-user-work.vue';
    import { debounce } from 'throttle-debounce';

    @Component({
        name:'zbb',
        components:{
            BatchIn,
            pbxxSchoolUserWorkVue
        }
    })
    export default class zbb extends Vue {

        debounceFunc = debounce(1000, true, this.submitUserAndDaybc);
        insertRules={
            bc: [{
                required: true,
                message: '请选择班次',
                trigger: ['blur', 'change']
            }]
        }
        dataNum=''
        currentyear=''
        currentmouth=''
        select=''
        selectData=''
        depts=[]
        isTitlip=false
        dept=''
        childDept=''
        thisdayInt = new Date().getDate()
        thismonthInt = new Date().getMonth()+1
        tableLoad=false
        childDepts=[]
        loading: boolean = false;
        pbTablelist=[]
        setbcVisible=false
        bc=''
        deptdisable=false
        childdeptdisable=false
        searchName = ''
        searchGw = ''
        dkTimes=[]
        form={
            selectId:'',
            isWork:'',
            bcTime:'',
            bc:'',
            ishx:0,
            iszb:0,
            gzlx: []
        }
        pbButtonLoading=false
        selectuserid=''  //选中的行用户id
        selectlabel='' //选中的列label值
        selectxm=''   //选中的行用户名
        selectid=''  //选中的单元格排班信息id
        currentPage=1  //当前页
        countsize=0   //总条目数
        batchVisible=false
        schoolUserBbxxVisible=false
        schoolUserWorkList = []
        mounted() {
            this.createTable();
            this.getDkTime();
        }
        createTable(){
            let date = new Date();
            this.currentyear=date.getFullYear();
            this.currentmouth=date.getMonth()+1;
            let dataNum = new Date(date.getFullYear(),date.getMonth()+1,0);
            this.dataNum=dataNum.getDate();
            let user=store.getters.user;
            console.log(user);
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                this.depts = res.data
                if(this.depts && this.depts[0]) {

                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.dept = this.depts[0].bmid
                                    this.deptdisable = true
                                    if(zw !='01') {
                                        this.childdeptdisable =true;
                                    }
                                    this.selectChanged2(this.dept)
                                }
                                this.selectChanged2(this.dept)
                            }
                        }

                    } else {this.selectChanged2(this.dept)}
                    this.selectChanged2(this.dept)

                }
            })
        }
        getDkTime() {
            this.$request.get('/bjba/dkTime/findAll').then(res => {
                this.dkTimes = res.data.data

                }
            )
        }
        queryBbxx(data : any) {
            let mouth='';
            if(this.currentmouth<10){
                mouth="0"+this.currentmouth;
            }else {mouth=this.currentmouth;}
            let date = this.currentyear+"-"+mouth;
            this.schoolUserBbxxVisible = true
            this.$nextTick(() => {
                this.$refs.schoolUserBbxx.init({xm: data.xm, userid: data.userid, month: date})
            })
        }
        showBatch() {
                this.batchVisible = true
                this.$nextTick(() => {
                    this.$refs.batchin.init()
                })
        }
        selectChanged2(value) {
            this.currentPage =1
            this.childDepts = []
            this.childDept =''
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.childDept = this.childDepts[0].bmid

                                }
                            }
                        }
                    }

                }


                this.selectChanged();
                // if(this.childDept && this.childDept.length ==1) this.form.childDept = this.childDept[0].bmid
            }).catch((err) => {
                console.log(err)
            })
        }
        selectChanged(){
            this.currentPage =1;
            this.getUser()
        }
        getUser() {
            this.tableLoad=true
            this.$request({
                method: 'post',
                url: '/bjba/pbgl/getUser',
                params:{bmid:this.dept,currentPage:this.currentPage,childBmid:this.childDept,username:this.$store.getters.username,searchName: this.searchName,searchGw: this.searchGw,type:0}
            }).then((response: any)=>{
                console.log(response.data)
                let usernum=response.data;
                let datalist=[];
                let useridlist=[];
                let xmlist=[];
                let gwlist=[];
                for (let i=0;i<usernum.length;i++){
                    datalist.push({xm:usernum[i].XM,userid:usernum[i].ID});
                    useridlist.push(usernum[i].ID);
                    xmlist.push(usernum[i].XM);
                    gwlist.push(usernum[i].GW);
                }
                let mouth='';
                if(this.currentmouth<10){
                    mouth="0"+this.currentmouth;
                }else {mouth=this.currentmouth;}
                let data=this.currentyear+"-"+mouth;
                let params={data:data,userid:useridlist,xm:xmlist,gw:gwlist};
                this.$request({
                    method: 'post',
                    url: '/bjba/pbgl/querypbxx',
                    data:params
                }).then((response: any)=>{
                    this.tableLoad=false
                    console.log(response);
                    this.pbTablelist=response.data;
                    console.log(this.pbTablelist);
                    this.gettotal();
                }).catch((err: any)=>{
                    this.tableLoad=false
                    console.log(err)
                });
            }).catch((err: any)=>{
                console.log(err)
            });
        }
        clickcell(row,column,cell,event) {
            console.log('row:',row)
            console.log('column:',column)
            if (isAuth('pb:set')) {
                this.selectuserid = row.userid;
                this.selectxm = row.xm;
                if (column.label == '岗位' || column.label == '姓名' || column.label == '出勤' || column.label == '加班' || column.label == '班别名称') {
                    return
                } else {
                    var labelDay = Number.parseInt(column.label);
                    var selectdate = new Date(this.currentyear, this.currentmouth - 1, labelDay)
                    var stamp1 = new Date(new Date().setHours(0, 0, 0, 0));
                    this.selectlabel = column.label;

                    if (stamp1.getTime() > selectdate.getTime()) {

                            if (isAuth('pb:updateold')) {
                                if (row[column.label]) {
                                    this.$request({
                                        method: 'get',
                                        url: '/bjba/pbgl/isDk/' + row[column.label].id
                                    }).then((response: any) => {

                                        var dkcs = response.data.data.dkcs;
                                        if (dkcs == 0) {
                                            this.showPbSet(row, column, false)
                                        } else {
                                            this.showPbSet(row, column, true)
                                        }
                                    }).catch((err: any) => {

                                        console.log(err)
                                    });
                                }else {
                                    this.form.selectId = '';
                                    this.form.bcTime = '';
                                    this.form.isWork = false;
                                    this.form.ishx = 0;
                                    this.form.iszb = 0;
                                    this.form.bc = row.type
                                    this.form.gzlx = []
                                    this.setbcVisible = true
                                    this.isTitlip = false
                                }
                            } else {
                                this.$message.error("无法修改已考勤排班")
                            }

                    }else if  (stamp1.getTime() == selectdate.getTime()) {
                            if (row[column.label]) {
                                this.$request({
                                    method: 'get',
                                    url: '/bjba/pbgl/isDk/' + row[column.label].id
                                }).then((response: any) => {

                                    var dkcs = response.data.data.dkcs;
                                    if (dkcs == 0) {

                                            this.showPbSet(row, column, false)

                                    } else {
                                    if (isAuth('pb:updateold')) {
                                        this.showPbSet(row, column, true)
                                    }
                                    else this.$message.error("无法修改已考勤排班")
                                    }
                                }).catch((err: any) => {

                                    console.log(err)
                                });
                            }else {
                                this.form.selectId = '';
                                this.form.bcTime = '';
                                this.form.isWork = false;
                                this.form.ishx = 0;
                                this.form.iszb = 0;
                                this.form.bc = row.type
                                this.setbcVisible = true
                                this.isTitlip = false
                            }
                    } else{
                        if (row[column.label]) {
                            this.showPbSet(row, column,false)
                        } else {
                            this.form.selectId = '';
                            this.form.bcTime = '';
                            this.form.isWork = false;
                            this.form.ishx = 0;
                            this.form.iszb = 0;
                            this.form.bc = row.type
                            this.form.gzlx = row.gzlx ? row.gzlx.split(',') : []
                            this.setbcVisible = true
                            this.isTitlip = false
                            // this.submitUserAndDaybc()
                        }
                    }

                }

            } else {
                this.$message.error("没有权限")
            }
        }
        showPbSet(row,column,isTitlip) {
            this.form.selectId=row[column.label].id;
            this.form.bc=row[column.label].bc;
            this.$set(this.form,'gzlx',row[column.label].gzlx ? row[column.label].gzlx.split(",") : '')
            this.form.isWork=JSON.parse(row[column.label].iswork);
            this.form.ishx=row[column.label].ishx;
            this.form.iszb=row[column.label].iszb;
            this.form.bcTime = row[column.label].bcTime
            this.setbcVisible =true
            this.isTitlip = isTitlip
        }
        openPb() {
            this.pbButtonLoading=false
        }
        dbclick(row,column,event){
            event.preventDefault();
                console.log('双-------------------------------------')
            if(isAuth('pb:set')) {
                this.selectuserid=row.userid;
                this.selectxm=row.xm;
                if (column.label=='序号'||column.label=='姓名' ||column.label=='出勤' || column.label=='加班' ){
                    return
                }else {
                    this.selectlabel=column.label;
                }
                if (row[column.label]){
                    this.selectid=row[column.label].id;
                    this.bc=row[column.label].bc;
                    this.form.isWork=true;
                    // this.setbcVisible =true
                    this.submitUserAndDaybc()

                }else {
                    this.selectid='';
                    this.bc=row.type;
                    this.form.isWork=true;
                    this.submitUserAndDaybc()
                }
            } else {
                this.$message.error("没有权限")
            }
        }
        addOrUpdatePb() {
            // throttle(this.submitUserAndDaybc,2000)()


        }
        deletebc() {
            this.$confirm('是否删除排班', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteUserAndDaybc()
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        }
        changeHx() {
            console.log('1111111111')
            if(this.form.ishx === 1) this.form.iszb = 0
        }
        changeZb() {
            if(this.form.iszb === 1) this.form.ishx = 0
        }
        submitUserAndDaybc(){
            this.pbButtonLoading=true
            if(!this.form.bc) {
                this.$message({
                    message: '请选择班次!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                this.pbButtonLoading=false
                return
            }
            if(this.form.iszb===0) {
                if(!this.form.bcTime) {
                    this.$message({
                        message: '请选择上班时间',
                        type: 'error',
                        center: true,
                        showClose: true
                    })
                    this.pbButtonLoading=false
                    return
                }
            } else {
                this.form.bcTime=''
            }
                    let userid=this.selectuserid;
                    let label=this.selectlabel;
                    let mouth=this.currentmouth;
                    if(mouth<10){
                        mouth="0"+mouth;
                    }
                    let data="";
                    if(label<10){
                        data=this.currentyear+"-"+mouth+"-0"+label;
                    }else{
                        data=this.currentyear+"-"+mouth+"-"+label;
                    }

                    let params={id:this.form.selectId,userid:userid,xm:this.selectxm,data:data,bc:this.form.bc,iswork:this.form.isWork,bcTime:this.form.bcTime,ishx:this.form.ishx,iszb:this.form.iszb,gzlx:this.form.gzlx.length !== 0 ? this.form.gzlx.join(",") : ''};
                    console.log(params);
                    this.$request({
                        method: 'post',
                        url: '/bjba/pbgl/insertdaybc',
                        data:params
                    }).then((response: any)=>{
                        console.log(response);
                        this.setbcVisible=false;
                        this.form.isWork=false;
                        this.bc='';
                        this.getUser(this.select);


                    }).catch((err: any)=>{
                        this.pbButtonLoading=false
                        console.log(err)
                    });


        }
        deleteUserAndDaybc(){
            if(!this.form.selectId) return
            this.$request({
                method: 'get',
                url: '/bjba/pbgl/deletedaybc',
                params:{id:this.form.selectId}
            }).then((response: any)=>{
                console.log(response);
                this.setbcVisible=false;
               this.getUser()
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch((err: any)=>{
                console.log(err)
            });
        }
        lastmonth(){
            let currentyear=this.currentyear;
            let currentmonth=this.currentmouth;
            if(currentmonth=="1"){
                let dataNum = new Date(currentyear-1,12,0);
                this.currentyear=currentyear-1;
                this.currentmouth=12;
                this.dataNum=dataNum.getDate();
                this.getUser(this.select);
                console.log(this.dataNum,this.currentyear,this.currentmouth);
            }else{
                let dataNum = new Date(currentyear,currentmonth-1,0);
                this.currentyear=currentyear;
                this.currentmouth=currentmonth-1;
                this.dataNum=dataNum.getDate();
                this.getUser(this.select);
                console.log(this.dataNum,this.currentyear,this.currentmouth);
            }
        }
        nextmonth(){
            let currentyear=this.currentyear;
            let currentmonth=this.currentmouth;
            if(currentmonth=="12"){
                let dataNum = new Date(currentyear+1,1,0);
                this.currentyear=currentyear+1;
                this.currentmouth=1;
                this.dataNum=dataNum.getDate();
                this.getUser(this.select);
                console.log(this.dataNum,this.currentyear,this.currentmouth);
            }else{
                let dataNum = new Date(currentyear,currentmonth+1,0);
                this.currentyear=currentyear;
                this.currentmouth=currentmonth+1;
                this.dataNum=dataNum.getDate();
                this.getUser(this.select);
                console.log(this.dataNum,this.currentyear,this.currentmouth);
            }
        }
        validate(data){
            let str='';
            // if(typeof data!='undefined'){
            //     if(typeof data.bc ==='string' && data.bc.length ){
            //         str=data.bcTime;
            //     }
            // }
            if(data) {
                if(data.ishx===1) str = "护"
                else if(data.iszb ===1) str = '值'
                else str=data.bcTime;
            }
            return str;
        }
        indexMethod(index) {
            return (index / 3)+1;
        }
        changestyle({rowIndex, columnIndex}){
            var style ={padding:"0px 0px", backgroundColor: '',color:''
            }
            if(typeof this.pbTablelist[rowIndex][columnIndex-1]!='undefined'){
                if(typeof this.pbTablelist[rowIndex][columnIndex-1].iswork ==='string' && this.pbTablelist[rowIndex][columnIndex-1].iswork.length){
                    if(this.pbTablelist[rowIndex][columnIndex-1].iswork=="true"){

                        style.backgroundColor="#7AFEC6"
                        return style
                    }else{

                        style.backgroundColor="#2894FF"
                        style.color="white"
                        return style
                    }
                }
            }
            return style
        }
        rowStyle({row, rowIndex}) {
            var style ={borderTop: '',height:'40px'}
            if (rowIndex % 3 == 0) {
                    style.borderTop="2px solid rgb(168 162 162)"
                    return style
            }
            return style
        }
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 1 || columnIndex-2 === this.dataNum || columnIndex-3 === this.dataNum || columnIndex-4 === this.dataNum) {
                if (rowIndex % 3 === 0) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }
        headerStyle({row, rowIndex,columnIndex}) {
           if(this.isNumber(row[columnIndex].label)) {
               return {
                   paddingRight:"0px"
               }
           }

        }
        countwork(row){
            let data=Object.keys(row);
            let j=0;
            for (let i=0;i<data.length;i++){
                if(typeof row[data[i]].iswork!='undefined'){
                    if (typeof row[data[i]].iswork==='string'&&row[data[i]].iswork.length){
                        if (row[data[i]].iswork==='false'){
                            j=j+1;
                        }
                    }
                }
            }
            return j;
        }
         isNumber(val) {
            var regPos = /^\d+(\.\d+)?$/; //非负浮点数
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
            if(regPos.test(val) || regNeg.test(val)) {
                return true;
            } else {
                return false;
            }
        }
        countovertime(row){
            let data=Object.keys(row);
            let j=0;
            for (let i=0;i<data.length;i++){
                if(typeof row[data[i]].iswork!='undefined'){
                    if (typeof row[data[i]].iswork==='string'&&row[data[i]].iswork.length){
                        if (row[data[i]].iswork==='true'){
                            j=j+1;
                        }
                    }
                }
            }
            return j;
        }
        handleCurrentChange(){
            this.getUser()
        }
        gettotal(){
            this.$request({
                method: 'get',
                url: '/bjba/pbgl/gettotal',
                params:{bmid:this.dept,childBmid:this.childDept,username:this.$store.getters.username,searchName: this.searchName,searchGw:this.searchGw,type:0}
            }).then((response: any)=>{
                this.countsize=response.data;
            }).catch((err: any)=>{
                console.log(err)
            });
        }
    }
